import clsx from 'clsx';
import React, { useEffect, useMemo, useRef } from 'react';
import styles from './styles.module.css';

interface SimpleVideoPlayerProps {
  src: string;
  width?: number;
  height?: number;
  isControls?: boolean;
  isAutoPlay?: boolean;
  isShowThumbnail?: boolean;
  isCenterPlayButton?: boolean;
}

const SimpleVideoPlayer: React.FC<SimpleVideoPlayerProps> = ({
  src,
  width = 360,
  height = 360,
  isAutoPlay = false,
  isControls = true,
  isShowThumbnail = false,
  isCenterPlayButton = true,
}) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  // TODO: check ?size= then remove it
  const formatSrc = useMemo(() => {
    if (src.includes('?size=')) {
      return src.replace(/\?size=\d+/, '');
    }
    return src;
  }, [src]);

  useEffect(() => {
    if (!isAutoPlay) {
      if (videoRef.current) {
        videoRef.current.pause();
      }
    }
  }, [isAutoPlay]);

  const handleClick = (e: React.MouseEvent<HTMLVideoElement, MouseEvent>) => {
    if (!isCenterPlayButton) {
      e.preventDefault();
      if (videoRef.current) {
        if (!videoRef.current.paused) {
          videoRef.current.pause();
        }
      }
    }
  };

  if (isShowThumbnail) {
    return (
      <div>
        <video src={formatSrc} width="50px" height="50px" className={'w-[50px] h-[50px]'} />
      </div>
    );
  }

  return (
    <div className="relative h-[inherit]">
      {src ? <span className="hide-func absolute bottom-[1.75rem] right-0 w-[60px] h-[40px] bg-transparent z-[99] cursor-not-allowed" /> : null}
      <video
        ref={videoRef}
        className={clsx(styles.targetVideo, 'cursor-pointer z-10 relative hover:shadow-lg h-[inherit]')}
        width={width}
        height={height}
        controls={isControls}
        autoPlay={isAutoPlay}
        controlsList="nodownload"
        onClick={handleClick}
        aria-label="video of product"
        aria-labelledby="video of product"
        muted={isAutoPlay}
      >
        <source src={formatSrc} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

export default SimpleVideoPlayer;
